import request from '@/services/interceptor.js'

export const get_pagamenti = (filtri) => {
    return request({
        url: '/pagamento',
        method: 'get',
        params: filtri || {},
        loadingBar: true
    })
}

export const get_pagamento = (id) => {
    return request({
        url: `/pagamento/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_pagamento = (par) => {
    return request({
        url: '/pagamento',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_pagamento = (id, par) => {
    return request({
        url: `/pagamento/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const completa_pagamento = (id, par) => {
    return request({
        url: `/pagamento/${id}/completa`,
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const duplica_pagamento = (id) => {
    return request({
        url: `/pagamento/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const elimina_pagamento = (id) => {
    return request({
        url: `/pagamento/${id}`,
        method: 'delete',
        loadingBar: true
    })
}
